import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";

import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    CardTitle,
    CardSubtitle,
    Container,
    FormGroup,
    Label,
} from "reactstrap";

import { AvForm, AvField, AvRadio, AvRadioGroup } from "availity-reactstrap-validation";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "react-tagsinput/react-tagsinput.css";

import showNotification from "../../helpers/show_notification";

import { postSubmitForm } from "../../helpers/forms_helper";

const AddStore = (props) => {

    useEffect(() => {
        loadAllStore();
        loadAllBranchCategories();
    }, []);

    const [allBranchCategories, setAllBranchCategories] = useState([]);
    const loadAllBranchCategories = async () => {
      let url = process.env.REACT_APP_BASEURL + "branchcategories/getall";
      let response = await postSubmitForm(url, "");
      if (response.status === 1) {
        setAllBranchCategories(response.data);
      } else {
        showNotification(response.message, "Error");
      }
    };

    const [allStore, setAllStore] = useState([]);
    const loadAllStore = async (e, v) => {
        let url = process.env.REACT_APP_BASEURL + "stores/getall";
        let response = await postSubmitForm(url, "");
        if (response.status === 1) {
            setAllStore(response.data);
        } else {
            showNotification(response.message, "Error");
        }
    };
    const refContainer = useRef(null);
    const [isPrivileged, setIsPrivileged] = useState(false);
    const [isStore, setIsStore] = useState(false);

    const [selectedType, setSelectedType] = useState('');

    const handleTypeChange = (event) => {
        setSelectedType(event.target.value);
    };
    const handleValidSubmit = async (e, v) => {
        try {
            let object = {
                name: v.name,
                type: v.type,
                address: v.address,
            };
            if (v.type === 'Branch') {
                object = {
                    ...object,
                    email: v.email,
                    mobile: v.mobile,
                    category: v.category,
                    opening_time: v.opening_time,
                    closing_time: v.closing_time,
                    is_store: isStore,
                    transfer_privilege: isPrivileged,
                };
            }
            if (v.type === 'Sub Store') {
                object = {
                    ...object,
                    email: v.email,
                    mobile: v.mobile,
                };
            }

            let url = process.env.REACT_APP_BASEURL + "stores/insert";
            let response = await postSubmitForm(url, object);
            if (response.status === 1) {
                loadAllStore();
                showNotification(response.message, "Success");
                setSelectedType("")
                setIsStore(false)
                setIsPrivileged(false)
                refContainer.current.reset();
            } else {
                showNotification(response.message, "Error");
            }
        } catch (error) {
            showNotification(error.message, "Error");
        }
    };

    const columns = [
        {
            text: "#",
            dataField: "_id",
            formatter: (cell, row, rowIndex) => {
                return rowIndex + 1
            },
            headerStyle: (colum, colIndex) => {
                return { width: "3%" };
            },
            //   hidden: true,
        },
        {
            text: props.t("Name"),
            //formatter: employeeFormatter,
            dataField: "name",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "16%" };
            },
        },
        {
            text: props.t("Type"),
            dataField: "type",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "16%" };
            },
        },
         {
            text: props.t("Address"),
            dataField: "address",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "16%" };
            },
        },
        {
            text: props.t("Category"),
            dataField: "category",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: "16%" };
            },
        },
        {
            dataField: "is_store",
            text: props.t("Store Exist"),
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "7%" };
            },
            formatter: (cell, row) => {
              return row.type === "Branch" ? row.is_store ? "Yes" : "No" : ""
            },
          },
        {
            dataField: "transfer_privilege",
            text: props.t("Transfer Privilege"),
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "9%" };
            },
            formatter: (cell, row) => {
              return row.type === "Branch" ? row.transfer_privilege ? "Yes" : "No" : ""
            },
          },
    ];

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs
                        title={props.t("Store / Branch")}
                        breadcrumbItem={props.t("Add Store")}
                    />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <AvForm onValidSubmit={handleValidSubmit} ref={refContainer}>
                                        <CardTitle>{props.t("Add Store / Branch")}</CardTitle>
                                        <CardSubtitle className="mb-3">
                                            {props.t(
                                                "Enter the following details to add a store / branch"
                                            )}
                                        </CardSubtitle>
                                        <Row>
                                            <Col lg={6}>
                                                <AvField
                                                    name="name"
                                                    label={props.t("Name")}
                                                    placeholder={props.t("Enter Store Name")}
                                                    type="text"
                                                    validate={{
                                                        required: {
                                                            value: true,
                                                            errorMessage: props.t("Name cannot be empty"),
                                                        },
                                                    }}
                                                />
                                            </Col>
                                            <Col lg={6}>
                                                <AvField
                                                    name="type"
                                                    label={props.t("Type")}
                                                    placeholder={props.t("Enter type")}
                                                    type="select"
                                                    onChange={handleTypeChange}
                                                    validate={{
                                                        required: {
                                                            value: true,
                                                            errorMessage: props.t("Type cannot be empty"),
                                                        },
                                                    }}
                                                >
                                                    <option value="">{props.t("--Select type--")}</option>
                                                    <option value="Main Store">{props.t("Main Store")}</option>
                                                    <option value="Sub Store">{props.t("Sub Store")}</option>
                                                    <option value="Branch">{props.t("Branch")}</option>
                                                </AvField>
                                            </Col>
                                            <Col lg={6}>
                                                <AvField
                                                    name="address"
                                                    label={props.t("Address")}
                                                    placeholder={props.t("Enter address")}
                                                    type="textarea"
                                                    validate={{
                                                        required: {
                                                            value: true,
                                                            errorMessage: props.t("Address cannot be empty"),
                                                        },
                                                    }}
                                                />
                                            </Col>
                                            {selectedType === 'Sub Store' && (
                                                <>
                                                               <Col lg={6}>
                                                               <AvField
                                                                 name="mobile"
                                                                 label={props.t("Contact Number")}
                                                                 placeholder={props.t("Enter Contact Number")}
                                                                 type="number"
                                                                 validate={{
                                                                   required: {
                                                                     value: true,
                                                                     errorMessage: props.t("Contact cannot be empty."),
                                                                   },
                                                                   pattern: {
                                                                     value: "^[0-9]+$",
                                                                     errorMessage: props.t(
                                                                       "Only numbers are allowed."
                                                                     ),
                                                                   },
                                                                   maxLength: {
                                                                     value: 8,
                                                                     errorMessage: props.t("Enter valid contact."),
                                                                   },
                                                                   minLength: {
                                                                     value: 8,
                                                                     errorMessage: props.t("Enter valid contact."),
                                                                   },
                                                                 }}
                                                               />
                                                             </Col>
                                                             <Col lg={6}>
                        <AvField
                          name="email"
                          label={props.t("Email")}
                          placeholder={props.t("Enter Email")}
                          type="email"
                          errorMessage={props.t("Enter valid email.")}
                        />
                      </Col>
                                                             </>
                                            )}
                                            {selectedType === 'Branch' && (
                                          <>
                                          <Col lg={6}>
                        <AvField
                          name="mobile"
                          label={props.t("Contact Number")}
                          placeholder={props.t("Enter Contact Number")}
                          type="number"
                          validate={{
                            required: {
                              value: true,
                              errorMessage: props.t("Contact cannot be empty."),
                            },
                            pattern: {
                              value: "^[0-9]+$",
                              errorMessage: props.t(
                                "Only numbers are allowed."
                              ),
                            },
                            maxLength: {
                              value: 8,
                              errorMessage: props.t("Enter valid contact."),
                            },
                            minLength: {
                              value: 8,
                              errorMessage: props.t("Enter valid contact."),
                            },
                          }}
                        />
                      </Col>
                      <Col lg={6}>
                        <AvField
                          name="email"
                          label={props.t("Email")}
                          placeholder={props.t("Enter Email")}
                          type="email"
                          errorMessage={props.t("Enter valid email.")}
                        />
                      </Col>
                      <Col lg={6}>
                                                              <AvField
                                                                type="select"
                                                                name="branch_category"
                                                                label={props.t("Branch Category")}
                                                                validate={{
                                                                  required: {
                                                                    value: true,
                                                                    errorMessage: props.t("branch category is required"),
                                                                  },
                                                                }}
                                                              >
                                                                <option value="">{props.t("--Select Branch Category--")}</option>
                                                                {allBranchCategories.map((data)=>
                                                                  {return(
                                                                    <option value={data.name} key={data._id}>{data.name}</option>
                                                                  )
                                                                })}
                                                              </AvField>
                                                            </Col>
                                            <Col lg={3}>
                        <AvField
                          name="opening_time"
                          label={props.t("Opening Time")}
                          placeholder={props.t("Enter Opening Time")}
                          type="time"
                          errorMessage={props.t("Opening time cannot be empty")}
                          validate={{
                            required: { value: true },
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvField
                          name="closing_time"
                          label={props.t("Closing Time")}
                          placeholder={props.t("Enter Closing Time")}
                          type="time"
                          errorMessage={props.t("Closing time cannot be empty")}
                          validate={{
                            required: { value: true },
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <AvRadioGroup
                          inline
                          name="is_store"
                          required
                          errorMessage={props.t("Select an option")}
                        >
                          <Label>{props.t("Store Exists?")}</Label>
                          <br />
                          <AvRadio
                            onChange={(e, v) => {
                              setIsStore(true);
                            }}
                            label="Yes"
                            value="Yes"
                          />
                          <AvRadio
                            onChange={(e, v) => {
                              setIsStore(false);
                            }}
                            label="No"
                            value="No"
                          />
                        </AvRadioGroup>
                      </Col>
                                        
                                                <Col lg={3} className="mt-2">
                                                <AvRadioGroup
                                                inline
                                                name="transfer_privilege"
                                                required
                                                errorMessage={props.t("Select an option")}
                                                >
                                                <Label>{props.t("Transfer Privileged?")}</Label>
                                                <br />
                                                <AvRadio
                                                    onChange={(e, v) => {
                                                    setIsPrivileged(true);
                                                    }}
                                                    label="Yes"
                                                    value="Yes"
                                                />
                                                <AvRadio
                                                    onChange={(e, v) => {
                                                    setIsPrivileged(false);
                                                    }}
                                                    label="No"
                                                    value="No"
                                                />
                                                </AvRadioGroup>
                                            </Col>
                                          </>
                                            )}

                                        </Row>
                                        <Row>
                                            <Col lg={12}>
                                                <hr />
                                                <FormGroup className="mb-0 text-center">
                                                    <div>
                                                        <Button
                                                            type="submit"
                                                            color="primary"
                                                            className="mr-1"
                                                        >
                                                            {props.t("Submit")}
                                                        </Button>{" "}
                                                    </div>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12">
                            <Card>
                                <CardBody>
                                    <CardTitle>{props.t("Existing Stores / Branches")} </CardTitle>
                                    <CardSubtitle className="mb-3">
                                        {props.t("View all your existing store here")}
                                    </CardSubtitle>
                                    <BootstrapTable
                                        bootstrap4
                                        keyField="_id"
                                        data={allStore && allStore}
                                        columns={columns}
                                        noDataIndication={props.t("No data to display.")}
                                        striped
                                        hover
                                        condensed
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default withRouter(connect(null, {})(withNamespaces()(AddStore)));
